import { config } from 'config';
import { i18nTravelPolicy } from 'i18n/i18nTravelPolicy';

const { isB2B } = config;

export const getTravelPolicyMessage = () => {
    return i18nTravelPolicy(isB2B ? 'b2b_not_complaint_warning' : 'are_you_ready_to_pay');
};
